import { useNavigate } from "react-router-dom";
import { ReactNode } from 'react';

interface PageLayoutProps {
  eyebrow?: string;
  title: ReactNode;
  subtitle?: string;
  children: ReactNode;
}

export default function PageLayout({ eyebrow, title, subtitle, children }: PageLayoutProps) {
  const navigate = useNavigate();

  return (
    <div style={S.page}>
      <style>{`
        @media (max-width: 768px) {
          .layout-hero { padding: 40px 16px 32px !important; }
          .layout-content { padding: 32px 16px 60px !important; }
          .layout-footer-inner { gap: 12px !important; flex-direction: column !important; }
        }
      `}</style>
      <div style={S.hero} className="layout-hero">
        <div style={S.heroInner}>
          <button onClick={() => navigate("/")} style={S.back}>← Overview</button>
          <div style={S.eyebrow}>{eyebrow}</div>
          <h1 style={S.title}>{title}</h1>
          {subtitle && <p style={S.subtitle}>{subtitle}</p>}
        </div>
      </div>

      <div style={S.content} className="layout-content">
        <div style={S.inner}>{children}</div>
      </div>

      <footer style={S.footer}>
        <div style={S.footerInner} className="layout-footer-inner">
          <span style={{ color: "var(--text-muted)", fontSize: 12 }}>Private Community Investment Fund · Est. Nov 2025</span>
        </div>
      </footer>
    </div>
  );
}

const S: Record<string, React.CSSProperties> = {
  page: { minHeight: "100vh", background: "var(--dark-bg)", display: "flex", flexDirection: "column" },
  hero: {
    background: `linear-gradient(180deg, rgba(10,15,14,0.6) 0%, rgba(10,15,14,0.95) 100%),
      url('https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1400&q=80') center/cover no-repeat`,
    padding: "60px 24px 48px",
    borderBottom: "1px solid rgba(255,255,255,0.06)",
    boxSizing: "border-box",
  },
  heroInner: { maxWidth: 860, margin: "0 auto" },
  back: {
    fontSize: 12, color: "var(--text-muted)", background: "none", border: "none",
    cursor: "pointer", padding: "0 0 20px", display: "block",
    letterSpacing: "0.04em", transition: "color 0.15s",
  },
  eyebrow: {
    fontSize: 10, letterSpacing: "0.2em", color: "var(--teal-dim)",
    fontWeight: 600, marginBottom: 12, textTransform: "uppercase",
  },
  title: {
    fontFamily: "var(--font-display)", fontSize: "clamp(24px,5vw,56px)",
    fontWeight: 700, color: "var(--text-primary)", lineHeight: 1.1, marginBottom: 16,
  },
  subtitle: { fontSize: "clamp(13px,2vw,16px)", color: "var(--text-secondary)", lineHeight: 1.7, maxWidth: 600 },
  content: { flex: 1, padding: "56px 24px 80px", boxSizing: "border-box" },
  inner: { maxWidth: 860, margin: "0 auto" },
  footer: {
    background: "rgba(0,0,0,0.4)", borderTop: "1px solid rgba(255,255,255,0.05)", padding: "24px",
  },
  footerInner: { maxWidth: 1200, margin: "0 auto", display: "flex", gap: 24, flexWrap: "wrap" },
};
